import { ClientBasicInfo } from "../../../workspaces/clients/viewClient/clientBasicInfo/clientBasicInfo.component";
import { ContractBasicInfo } from "../../../workspaces/contracts/viewContract/contractBasicInfo/contractBasicInfo.component";
import { EquipmentBasicInfo } from "../../../workspaces/equipments/equipmentsList/viewEquipment/equipmentBasicInfo/equipmentBasicInfo.component";
import { JobBasicInfo } from "../../../workspaces/service/jobs/viewJob/jobBasicInfo.component";
import { ExternalServiceBasicInfo } from "../../../workspaces/service/externalServices/viewExternalService/externalServiceBasicInfo.component";
import { OrderedPartBasicInfo } from "../../../workspaces/service/stockStatus/viewPart/orderedPartBasicInfo.component";
import { EntityReferenceType } from "../../../utils/entityRoutes";

type EntityPreviewPageProps = {
  entityType: EntityReferenceType;
  entityId: string | number;
};

export const EntityPreviewPage = ({ entityType, entityId }: EntityPreviewPageProps) => {
  switch (entityType) {
    case "client":
      return <ClientBasicInfo previewId={entityId} />;
    case "contract":
      return <ContractBasicInfo previewId={entityId} />;
    case "equipment":
      return <EquipmentBasicInfo previewId={entityId} />;
    case "job":
      return <JobBasicInfo previewId={entityId} />;
    case "externalService":
      return <ExternalServiceBasicInfo previewId={entityId} />;
    case "orderedPart": {
      // Composite "partId/orderedPartId" - the basic info component only
      // needs the ordered part's own id to fetch it.
      const orderedPartId = String(entityId).split("/").pop();
      return <OrderedPartBasicInfo previewId={orderedPartId} />;
    }
    default:
      return null;
  }
};
